/**
 * The DSCR tab — one screen, two entry depths.
 *
 * `/sizers/dscr` renders the full sizer; `?entry=quick` renders Quick
 * Entry. They used to be two Admin → Sizers tabs, which read as two tools when
 * they are one: both post `POST /pricing/scenario/dscr_quick`, render the same
 * `DscrResultsColumn`, and persist to the same scenario store. What differs is
 * how many questions get asked, and that is a mode, not a destination.
 *
 * The mode is a QUERY param rather than a path segment because the admin sub-tab
 * strip highlights on `pathname.startsWith(subTab.to)` — a second path would
 * need a second nav entry, which is the thing being removed. The switcher itself
 * is `sizersShared/DscrEntryTabs`, rendered by each screen through
 * `SizerShell`'s `tabs` slot so it sits under the title where it belongs.
 */
import { useSearchParams } from "react-router-dom";

import { isScenarioId } from "../../../api/sizerApi";

import DscrSizerScreen from "../../DscrSizerScreen/DscrSizerScreen";
import DscrQuickEntrySizer from "./DscrQuickEntrySizer";
import { dscrEntryMode } from "../../sizersShared/DscrEntryTabs";

export default function DscrSizerTabs() {
  const [searchParams] = useSearchParams();
  // A resumed scenario always opens in the FULL form: quick entry asks a subset
  // of these questions and has no resume path, so it could not load one back.
  // A real id, not the string "null" — the same guard the sizers themselves
  // apply, so the two never disagree about whether a scenario is being resumed.
  const resuming = isScenarioId(searchParams.get("scenario"));

  return !resuming && dscrEntryMode(searchParams) === "quick" ? (
    <DscrQuickEntrySizer />
  ) : (
    <DscrSizerScreen />
  );
}
